<template>
  <div
    class="sliding-router-view"
    :class="{
      'sliding-router-view-hidden': !visible,
      'sliding-router-view-no-transition': noTransition,
    }"
  >
    <router-view v-slot="{ Component }" :name="name">
      <keep-alive>
        <component :is="Component" />
      </keep-alive>
    </router-view>
    <div class="sliding-router-navbar">
      <button @click="back" class="btn btn-lg btn-primary-back" type="button">Back</button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { slidingHref } from "../router/router";
import SwipeNavigationInfo from "./swipe-navigation-info";

const props = withDefaults(
  defineProps<{
    name: string;
  }>(),
  {
    name: "sliding1",
  },
);

const route = useRoute();

const noTransition = ref(false);

const href = ref("");
const visible = computed(() => {
  return !!href.value;
});

function back(): void {
  window.history.back();
}

function lockBodyScroll(): void {
  if (props.name === "sliding1") {
    document.documentElement.classList.add("body-scroll-locked");
  }
}

function unlockBodyScroll(): void {
  if (props.name === "sliding1") {
    document.documentElement.classList.remove("body-scroll-locked");
  }
}

watch(
  () => route.query,
  (newVal) => {
    noTransition.value = SwipeNavigationInfo.wasSwipeNavigation();
    if (route && route.matched && route.matched[0] && route.matched[0].components) {
      href.value = slidingHref(route, props.name);
    } else {
      href.value = "";
    }

    if (visible.value) {
      lockBodyScroll();
    } else {
      unlockBodyScroll();
    }
  },
  { immediate: true },
);
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@import (reference) "../styles/bootstrap/variables.less";

.sliding-router-navbar {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  padding: 15px;
  background-color: #666;
  z-index: 10;

  // a {
  //   line-height: @navbar-height;
  //   padding-left: 15px;
  //   font-size: 18px;
  // }
}

.sliding-router-view {
  transition: transform 0.5s ease, visibility 0.5s;
  height: 100%;
  position: fixed;
  width: 100vw;
  top: 0;
  left: 0;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  z-index: 1050;
  background-color: white;
  padding-top: 75px;
  box-shadow: 0px -5px 10px #333;

  &.sliding-router-view-hidden {
    transform: translateX(100%);

    visibility: hidden;
  }

  &.sliding-router-view-no-transition {
    transition: none;
  }

  // This refers to the back button inside resource views, not the back button in the top left of these views.
  .back-button {
    display: none;
  }
}

// Layers beyond the first are not actually necessary.
html.body-scroll-locked {
  position: relative;
  min-height: 100%;
  overflow: hidden;

  body {
    position: relative;
    min-height: 100%;
    overflow: hidden;
  }

  // Stop the cs-router-view from moving when the scrollbar dissapears.
  .cs-router-view {
    overflow-y: scroll;
  }
}
</style>
